import React, { RefObject, useEffect, useState } from "react";
import { Textarea } from "@mui/joy";
import { theme } from "styles/theme";

interface TextareaRefundProps {
  placeholder?: string;
  initialValue?: string;
  handleChange: (value: string) => void;
  isFocused: boolean;
  setIsFocused: React.Dispatch<React.SetStateAction<boolean>>;
  inputRef?: RefObject<HTMLTextAreaElement>;
}

export default function TextareaRefund({
  placeholder,
  initialValue,
  handleChange,
  isFocused,
  setIsFocused,
  inputRef,
}: TextareaRefundProps) {
  const [value, setValue] = useState(initialValue);

  useEffect(() => {
    if (!isFocused) {
      setValue(initialValue);
    }
  }, [initialValue, isFocused]);

  return (
    <Textarea
      placeholder={placeholder}
      value={value || ""}
      maxRows={500}
      onChange={(e) => {
        let newValue = e.target.value;

        setValue(newValue);
        handleChange(newValue);
      }}
      readOnly={false}
      minRows={10}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      slotProps={{
        textarea: {
          ref: inputRef,
          inputMode: "text",
          maxLength: 500,
        },
      }}
      sx={{
        width: "100%",
        height: "100%",
        boxShadow: "none",
        backgroundColor: "transparent",
        padding: "12.5px 16px",
        border: "none",
        minWidth: 0,
        minHeight: "24px",
        "--joy-focus-thickness": "0px",
        "--variant-borderWidth": "0px",
        "--Textarea-gap": "0px",
        "& textarea": {
          textAlign: "left",
          padding: 0,
          margin: 0,
          fontWeight: 500,
          color: theme.vars.palette.Content.Strong,
          whiteSpace: "pre-wrap",
          overflowX: "hidden",
          resize: "none",
          fontSize: "16px",
          lineHeight: "132%",
        },
        "& textarea::placeholder": {
          textAlign: "left",
          whiteSpace: "pre-wrap",
          fontWeight: 500,
          color: theme.vars.palette.Content.SuperWeak,
          fontSize: "16px",
          lineHeight: "132%",
        },
      }}
    />
  );
}
